import { useAuth0 } from "@auth0/auth0-react";
import { getComponents } from "api/ComponentsApi";
import { tryCatchWrapper } from "helpers/common";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setComponents } from "redux/actions/flowDesigner/cxfComponentsActionCreator";

let isFetching = false;

export const useOwnedConnectors = () => {
  const { user } = useAuth0();
  const { components } = useSelector((store) => store.designer.cxfComponents);
  const dispatch = useDispatch();

  const handleFetchOwnedConnectors = async () => {
    if (!user) return;

    const componentsResponse = await getComponents(user?.stripeId);

    dispatch(setComponents(componentsResponse));
  };

  useEffect(() => {
    if (isFetching || !user?.stripeId || components?.length) return;

    isFetching = true;
    tryCatchWrapper(handleFetchOwnedConnectors)();
  }, [user?.stripeId]);

  return {
    ownedConnectors: components,
    handleFetchOwnedConnectors,
  };
};
